import { REPORTSUMMARYDEPARTMENT_SUCCESS, REPORTSUMMARYDEPARTMENT_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const reportSummaryDepartmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case REPORTSUMMARYDEPARTMENT_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case REPORTSUMMARYDEPARTMENT_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default reportSummaryDepartmentReducer;
